import { render, staticRenderFns } from "./downRate.vue?vue&type=template&id=1aef5f0e&scoped=true&"
import script from "./downRate.vue?vue&type=script&lang=js&"
export * from "./downRate.vue?vue&type=script&lang=js&"
import style0 from "./downRate.vue?vue&type=style&index=0&id=1aef5f0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef5f0e",
  null
  
)

export default component.exports